<template>
  <div>
    <availability-check-wizard-main
      v-if="campsite"
      :campsite="campsite"
      :pitchtype="pitchtype"
    />
    <client-only>
      <PortalTarget name="portal-target" />
      <PortalTarget name="popover-target" class="portal-target" />
    </client-only>
  </div>
</template>

<script setup lang="ts">
import { useAsyncData } from 'nuxt/app'
import { PitchType } from '../../../apps/campsite-details/types'
import { campsiteFetchingPageAsyncData } from '../../../components/pages/CampsiteFetchingPage'
import { logger } from '../../../utility/logger'

definePageMeta({
  layout: 'basic',
})

useHead({
  meta: [
    {
      hid: 'robots',
      name: 'robots',
      content: 'noindex',
    },
  ],
})

const route = useRoute()

const { data: result, error } = await useAsyncData(
  `campsite-${route.params.slug}`,
  async (nuxtApp) => {
    logger('check-availability.useAsyncData', route.params.slug)
    return await campsiteFetchingPageAsyncData({
      route: {
        params: {
          slug: route.params.slug as string,
          lang: route.params.lang as string,
        },
        query: route.query,
        path: route.path,
        fullPath: route.fullPath,
        meta: route.meta,
      },
      defaultAdultsCount: Number(useRuntimeConfig().public.defaultAdultsCount),
      error: (params) => {
        throw createError(params)
      },
      async redirect(code, url) {
        return await nuxtApp?.runWithContext(async () => {
          await navigateTo(url, { redirectCode: code })
        })
      },
    })
  },
)

if (error.value) {
  throw createError({
    statusCode: 404,
    statusMessage: `Page Not Found campsite detail ${route.params.slug}`,
    fatal: process.client, // Only set fatal true on client-side
  })
}

const { campsite } = result.value || {}

const pitchtypeId = computed<string | null>(() => {
  const query = route.query || {}
  return Array.isArray(query.pitchtype) ? query.pitchtype[0] : query.pitchtype
})

const pitchtype = computed<PitchType | undefined>(() => {
  if (!pitchtypeId) {
    return undefined
  }
  const pitchtypes = campsite?.pitchtypes || []
  return pitchtypes.find(
    (pitchtype) => String(pitchtype.id) === String(pitchtypeId),
  )
})
</script>
